import React from 'react';
import './Header.css';
import logo from '../../assets/erledix-logo-base-bg.png';
import { Link } from 'react-router-dom';

export function Header({ style }: React.HTMLAttributes<HTMLDivElement> = {}) {
	return (
		<div className='header' style={style}>
			<Link to='/' className='header-link'>
				<img src={logo} alt='Erledix Logo' className='header-logo'></img>
			</Link>
		</div>
	);
}
